import { REVIEW_TEST_IDS } from '@/components/admin/sessions/contracts';
import { markClass } from '@/components/admin/sessions/review/review-marks';
import { cn } from '@/lib/utils';

/**
 * The five marks above the transcript (relecture.md §4.3): ranged, annotated,
 * questioned, and the two families of a question of the interviewer. A legend is
 * what lets the page carry no sentence of explanation: the marks are read at a
 * glance and this is where they are named.
 *
 * Drawn with the SAME classes as the real marks (`markClass`), never a copy: a
 * legend that drifted from what it names would teach the wrong thing.
 */

const SAMPLE = 'inline-block text-sm leading-[22px]';

export function ReviewLegend() {
  return (
    <div
      data-testid={REVIEW_TEST_IDS.legend}
      className="flex flex-wrap items-center gap-x-4 gap-y-1.5 rounded-md border border-gray-200 px-2.5 py-1.5 text-gray-600 text-xs"
    >
      <span className="font-bold uppercase tracking-wide">Légende</span>
      <span className={SAMPLE}>
        <span
          className={cn(markClass({ doubt: false, noted: false, label: '2' }), 'cursor-default')}
          data-k="2"
        >
          rangé
        </span>
      </span>
      <span className={SAMPLE}>
        <span
          className={cn(markClass({ doubt: false, noted: true, label: '2' }), 'cursor-default')}
          data-k="2"
        >
          annoté
        </span>
      </span>
      <span className={SAMPLE}>
        <span
          className={cn(markClass({ doubt: true, noted: false, label: '2?' }), 'cursor-default')}
          data-k="2?"
        >
          questionné
        </span>
      </span>
      <span className={SAMPLE}>
        <span className="rounded-sm bg-vert-tint px-1 before:mr-1 before:font-bold before:text-micro before:text-vert-deep before:uppercase before:tracking-[0.04em] before:content-['Va']">
          question
        </span>
      </span>
      <span className={SAMPLE}>
        <span className="rounded-sm bg-rouge-tint px-1 before:mr-1 before:font-bold before:text-micro before:text-rouge-deep before:uppercase before:tracking-[0.04em] before:content-['Ne_va_pas']">
          question
        </span>
      </span>
    </div>
  );
}
